import { useMemo } from 'react';
import { MenuItem } from '../../data/MenuItem.interface';
import { menuItems } from '../../data/menuItems';
import { useAdminPermissions, UseAdminPermissions } from '../../hooks/useAdminPermissions';
import SidenavMenuItem from './SidenavMenuItem';

const canSeeMenuItem = (item: MenuItem, perms: UseAdminPermissions): boolean => {
  if (item.viewPermission && !perms.hasPermission(item.viewPermission)) return false;
  if (item.viewAnyOf && !perms.hasAny(item.viewAnyOf)) return false;
  return true;
};

const filterMenuItems = (items: MenuItem[], perms: UseAdminPermissions): MenuItem[] =>
  items
    .filter(item => canSeeMenuItem(item, perms))
    .map(item =>
      item.menuItems ? { ...item, menuItems: filterMenuItems(item.menuItems, perms) } : item
    )
    // Drop a parent whose visible children all collapsed away.
    .filter(item => !item.menuItems || item.menuItems.length > 0);

const SidenavMenu: React.FC<{ isCollapsed?: boolean }> = ({ isCollapsed = false }) => {
  const currentPath = window.location.pathname;
  const perms = useAdminPermissions();

  const menuItemsFiltered = useMemo(() => filterMenuItems(menuItems, perms), [perms]);

  return (
    <div className="space-y-1">
      {menuItemsFiltered?.map(menuItem => (
        <SidenavMenuItem
          key={menuItem.path}
          currentPath={currentPath}
          path={menuItem.path}
          icon={menuItem.icon}
          title={menuItem.title}
          menuItems={menuItem.menuItems}
          external={menuItem.external}
          isCollapsed={isCollapsed}
        />
      ))}
    </div>
  );
};

export default SidenavMenu;
